import { createClient } from '@supabase/supabase-js';

// Create a single supabase client for your application
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase URL or Anonymous Key not found in environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);